<div class="flex flex-col justify-start items-center">
  <div class="w-full flex justify-center items-center title-heading">
    <div class="flex justify-start items-center justify-self-start margin-right-auto icon-header">
      <div class="icon-container">
        <mat-icon svgIcon="manage-white"></mat-icon>
      </div>
      <div>
        <h1>{{ account.displayLabel }}</h1>
      </div>
    </div>
  </div>
</div>

<div class="page-container">
  <div class="top-metrics-container">
    <div class="top-metric">
      <div>
        <span class="metric">
          <mat-icon svgIcon="electricity"></mat-icon>
          {{ accountBessPower }}
        </span>
        <span>kW</span>
      </div>
      <div>Total BESS Power (kW)</div>
    </div>

    <div class="top-metric">
      <div>
        <span class="metric">
          <mat-icon svgIcon="battery"></mat-icon>
          {{ accountEnergyCapacity }}
        </span>
        <span>kWh</span>
      </div>
      <div>Total BESS Energy (kWh)</div>
    </div>
  </div>

  <div class="section-container">
    <div class="section-header-container">
      <span class="section-header" data-automation="site-locations-label">
        {{ 'sites.locations' | translate }}
      </span>
    </div>

    <div id="map-detail" class="map-container">
      <map-view [zoom]="globalZoom" [usePanning]="true" [latitude]="globalLatitude" [longitude]="globalLongitude">
        @for (site of account.children; track $index) {
          <map-marker [latitude]="site.latitude" [longitude]="site.longitude"></map-marker>
        }
      </map-view>
    </div>
  </div>

  <div class="section-container mt-8">
    <div class="section-header-container">
      <span class="section-header" data-automation="current-status-label">
        {{ 'sites.overview' | translate }}
      </span>
    </div>

    <monitor-ui-site-table [sites]="account.children"></monitor-ui-site-table>
  </div>

  <div class="section-container mt-8">
    <div class="section-header-container">
      <span class="section-header" data-automation="current-status-label">
        {{ 'aggregated.demand.profile' | translate }}
      </span>
    </div>

    <div class="chart-container">
      <div class="chart-top-labels">
        <span class="chart-left-label">{{ 'aggregated.demand.current_data' | translate }}</span>
        <span class="chart-right-label">{{ 'aggregated.demand.future_predictions' | translate }}</span>
      </div>
      <div id="account-energy-rates-chart-container">
        <monitor-ui-multi-stat-chart
          [entity]="account"
          [stats]="[aggregatedBuildingDemandStats, siteMeterStats]"
          [seriesLabels]="[aggregatedBuildingDemandLabel, siteMeterLabel]"
          [colors]="['#008285', '#C2185B']"
          [chartId]="'account-energy-rates-chart'"
          [titleKey]="'profile.chart.y.axis'"
          [containerSelector]="'.chart-container'"
        ></monitor-ui-multi-stat-chart>
      </div>
    </div>
  </div>
</div>
